import { ANALYTICS_SUITE_TAB_IDS } from '../types/navigation';
import { USE_CASE_IDS } from '../types/filters';
import { ALL_USE_CASES, USE_CASES_BY_TAB } from '../constants/filters';
export const getUseCasesForTab = (tabId, activeUseCaseId) => {
  if (tabId === ANALYTICS_SUITE_TAB_IDS.DISCOVER) {
    return ALL_USE_CASES;
  }
  const tabUseCases = USE_CASES_BY_TAB[tabId];
  if (!tabUseCases) {
    return [];
  }
  let useCases = [...tabUseCases];
  // ensure active use case is included even if it doesn't belong to this tab
  if (activeUseCaseId) {
    const isActiveUseCaseInTab = useCases.some(useCase => useCase.id === activeUseCaseId);
    if (!isActiveUseCaseInTab) {
      const activeUseCase = ALL_USE_CASES.find(useCase => useCase.id === activeUseCaseId);
      if (activeUseCase) {
        useCases = [activeUseCase, ...useCases];
      }
    }
  }
  return useCases;
};
export const getTabForUseCase = useCaseId => {
  for (const [tabId, useCases] of Object.entries(USE_CASES_BY_TAB)) {
    if (useCases.some(useCase => useCase.id === useCaseId)) {
      return tabId;
    }
  }
  return ANALYTICS_SUITE_TAB_IDS.DISCOVER;
};
export const reorderUseCases = (useCases, selectedUseCaseId) => {
  if (!selectedUseCaseId) {
    // Return to original order when no use case is selected
    return [...useCases].sort((a, b) => a.originalIndex - b.originalIndex);
  }
  const selectedIndex = useCases.findIndex(useCase => useCase.id === selectedUseCaseId);
  if (selectedIndex === -1) {
    return useCases;
  }

  // Move selected use case to the front
  const reordered = [...useCases];
  const [selectedUseCase] = reordered.splice(selectedIndex, 1);
  return [selectedUseCase, ...reordered];
};
export const isValidUseCaseId = useCaseId => {
  return Object.values(USE_CASE_IDS).includes(useCaseId);
};